<template>
    <div class="mc">
        <!-- ============ EN-TÊTE ============ -->
        <header class="mc-header">
            <button class="mc-back" aria-label="Retour à la carte" @click="$emit('retour')">
                <i class="ri-arrow-left-line"></i>
            </button>
            <h1 class="mc-title">Ma commande</h1>
            <div v-if="tableLabel" class="mc-table">{{ tableLabel }}</div>
        </header>

        <!-- ============ PANIER VIDE ============ -->
        <main v-if="!cart.length" class="mc-vide">
            <div class="mc-vide-illu">
                <i class="ri-shopping-basket-2-line"></i>
                <span class="mc-vide-bulle mc-vide-b1"></span>
                <span class="mc-vide-bulle mc-vide-b2"></span>
                <span class="mc-vide-bulle mc-vide-b3"></span>
            </div>
            <h2>Votre commande est vide</h2>
            <p>C'est le moment de se faire plaisir ! Parcourez la carte et trouvez votre bonheur.</p>
            <button class="mc-btn" @click="$emit('retour')">
                Voir la carte <i class="ri-arrow-right-line"></i>
            </button>
        </main>

        <!-- ============ PANIER ============ -->
        <template v-else>
            <main class="mc-main">
                <div class="mc-list">
                    <article v-for="line in cart" :key="line.lineId" class="mc-line">
                        <div class="mc-thumb">
                            <img v-if="line.image" :src="line.image" :alt="line.libelle" loading="lazy">
                            <div v-else class="mc-thumb-vide"><i class="ri-restaurant-line"></i></div>
                        </div>

                        <div class="mc-line-body">
                            <div class="mc-line-top">
                                <div class="mc-line-txt">
                                    <h3>{{ line.libelle }}</h3>
                                    <p v-if="sousTitre(line)" class="mc-line-opt">{{ sousTitre(line) }}</p>
                                    <p v-if="line.note" class="mc-line-note">« {{ line.note }} »</p>
                                </div>
                                <button class="mc-del" :aria-label="'Retirer ' + line.libelle"
                                        @click="$emit('supprimer', line)">
                                    <i class="ri-delete-bin-line"></i>
                                </button>
                            </div>

                            <div class="mc-line-bottom">
                                <span class="mc-line-prix">{{ fmt(line.unitPrice * line.qte) }}</span>
                                <div class="mc-stepper">
                                    <button aria-label="Diminuer" @click="$emit('quantite', line, -1)">
                                        <i class="ri-subtract-line"></i>
                                    </button>
                                    <span>{{ line.qte }}</span>
                                    <button aria-label="Augmenter" @click="$emit('quantite', line, 1)">
                                        <i class="ri-add-line"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>

                <button class="mc-plus" @click="$emit('retour')">
                    <i class="ri-add-line"></i> Ajouter un autre plat
                </button>

                <div class="mc-champ">
                    <label for="mc-nom">Votre nom (facultatif)</label>
                    <input id="mc-nom" type="text" placeholder="Pour que le serveur vous retrouve…"
                           :value="clientNom" @input="$emit('update:clientNom', $event.target.value)">
                </div>

                <div class="mc-recap">
                    <div class="mc-recap-row">
                        <span>Sous-total</span>
                        <span class="mc-recap-val">{{ fmt(total) }}</span>
                    </div>
                    <div class="mc-recap-sep"></div>
                    <div class="mc-recap-row">
                        <span class="mc-recap-lbl">Total</span>
                        <span class="mc-recap-total">{{ fmt(total) }}</span>
                    </div>
                    <p class="mc-recap-note">
                        <i class="ri-information-line"></i>
                        Vous réglerez au comptoir après le repas.
                    </p>
                </div>
            </main>

            <!-- ============ ENVOI ============ -->
            <footer class="mc-cta">
                <button class="mc-btn" :disabled="submitting" @click="$emit('envoyer')">
                    <template v-if="submitting">
                        <i class="ri-loader-4-line mc-spin"></i> Envoi en cours…
                    </template>
                    <template v-else>
                        Envoyer à la cuisine <i class="ri-send-plane-2-fill"></i>
                    </template>
                </button>
            </footer>
        </template>
    </div>
</template>

<script>
    /* eslint-disable */
    import { fmt } from "./format";

    export default {
        name: "macommande",
        props: {
            cart: { type: Array, default: () => [] },
            total: { type: Number, default: 0 },
            tableLabel: { type: String, default: "" },
            clientNom: { type: String, default: "" },
            submitting: { type: Boolean, default: false },
        },
        emits: ["retour", "supprimer", "quantite", "envoyer", "update:clientNom"],
        methods: {
            fmt,
            // « Poulet entier · Riz parfumé, Aloco »
            sousTitre(line) {
                const bouts = [];
                if (line.tarifLibelle) bouts.push(line.tarifLibelle);
                if (line.accompagnements && line.accompagnements.length) {
                    bouts.push(line.accompagnements.join(", "));
                }
                return bouts.join(" · ");
            },
        },
    };
</script>

<style scoped>
    /* eslint-disable */
    .mc { display: flex; flex-direction: column; min-height: 100vh; }

    /* ---------- En-tête ---------- */
    .mc-header {
        position: sticky; top: 0; z-index: 40;
        display: flex; align-items: center; gap: var(--sp-sm);
        padding: var(--sp-md) var(--sp-pad);
        background: var(--c-surface);
        background: color-mix(in srgb, var(--c-surface) 92%, transparent);
        backdrop-filter: blur(14px); -webkit-backdrop-filter: blur(14px);
    }
    .mc-back {
        width: 44px; height: 44px; flex-shrink: 0; border-radius: 999px; cursor: pointer;
        border: 1px solid var(--c-outline-variant); background: var(--c-surface);
        color: var(--c-on-surface); font-size: 1.25rem;
        display: flex; align-items: center; justify-content: center;
        transition: transform 0.12s;
    }
    .mc-back:active { transform: scale(0.92); }
    .mc-title {
        flex: 1; margin: 0; font-size: 24px; line-height: 30px;
        font-weight: 800; letter-spacing: -0.01em; color: var(--c-primary);
    }
    .mc-table {
        flex-shrink: 0; background: var(--c-surface-container); color: var(--c-primary);
        font-size: 13px; font-weight: 700; padding: 6px 14px; border-radius: 999px;
    }

    /* ---------- Panier vide ---------- */
    .mc-vide {
        flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center;
        text-align: center; padding: var(--sp-xl) var(--sp-xl) 96px;
    }
    .mc-vide-illu {
        position: relative; width: 128px; height: 128px; margin-bottom: var(--sp-lg);
        border-radius: 999px; background: var(--c-surface-container);
        display: flex; align-items: center; justify-content: center;
    }
    .mc-vide-illu > i { font-size: 3.6rem; color: var(--c-primary); animation: mc-float 2.6s ease-in-out infinite; }
    @keyframes mc-float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-7px); } }
    .mc-vide-bulle {
        position: absolute; border-radius: 999px; background: var(--c-primary); opacity: 0.18;
    }
    .mc-vide-b1 { width: 14px; height: 14px; top: 10px; right: 14px; animation: mc-float 2.2s ease-in-out infinite; }
    .mc-vide-b2 { width: 9px; height: 9px; bottom: 18px; left: 10px; animation: mc-float 3s ease-in-out infinite 0.3s; }
    .mc-vide-b3 { width: 6px; height: 6px; top: 30px; left: 4px; animation: mc-float 2.6s ease-in-out infinite 0.6s; }
    .mc-vide h2 {
        margin: 0 0 var(--sp-xs); font-size: 24px; line-height: 30px;
        font-weight: 800; letter-spacing: -0.01em; color: var(--c-on-surface);
    }
    .mc-vide p {
        margin: 0 0 var(--sp-xl); font-size: 16px; line-height: 24px;
        color: var(--c-on-surface-variant); max-width: 300px;
    }
    .mc-vide .mc-btn { max-width: 260px; }

    /* ---------- Liste ---------- */
    .mc-main { flex: 1; padding: var(--sp-xs) var(--sp-pad) 132px; }
    .mc-list { display: flex; flex-direction: column; gap: var(--sp-sm); }
    .mc-line {
        display: flex; gap: var(--sp-md); padding: var(--sp-sm);
        background: var(--c-surface); border: 1px solid var(--c-outline-variant);
        border-radius: 16px;
    }
    .mc-thumb {
        width: 84px; height: 84px; flex-shrink: 0; border-radius: 14px;
        overflow: hidden; background: var(--c-surface-container);
    }
    .mc-thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
    .mc-thumb-vide {
        width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;
        color: var(--c-outline); font-size: 1.7rem;
    }
    .mc-line-body { flex: 1; min-width: 0; display: flex; flex-direction: column; justify-content: space-between; }
    .mc-line-top { display: flex; align-items: flex-start; gap: var(--sp-xs); }
    .mc-line-txt { flex: 1; min-width: 0; }
    .mc-line-txt h3 {
        margin: 0; font-size: 17px; line-height: 22px; font-weight: 700; color: var(--c-on-surface);
    }
    .mc-line-opt {
        margin: 3px 0 0; font-size: 13px; line-height: 18px; font-weight: 600;
        color: var(--c-on-surface-variant);
    }
    .mc-line-note {
        margin: 3px 0 0; font-size: 13px; line-height: 18px; font-style: italic;
        color: var(--c-outline);
    }
    .mc-del {
        flex-shrink: 0; width: 34px; height: 34px; border: none; background: transparent;
        color: var(--c-outline); font-size: 1.1rem; cursor: pointer;
        display: flex; align-items: center; justify-content: center; border-radius: 999px;
        transition: color 0.15s, background 0.15s;
    }
    .mc-del:hover { color: var(--c-error); background: var(--c-error-container); }
    .mc-line-bottom {
        display: flex; align-items: center; justify-content: space-between;
        gap: var(--sp-xs); margin-top: var(--sp-sm);
    }
    .mc-line-prix {
        font-size: 18px; font-weight: 700; color: var(--c-primary);
        font-variant-numeric: tabular-nums;
    }
    .mc-stepper {
        display: flex; align-items: center; gap: 2px; padding: 3px;
        background: var(--c-surface-low); border-radius: 999px;
    }
    .mc-stepper button {
        width: 34px; height: 34px; border: none; border-radius: 999px; cursor: pointer;
        background: var(--c-surface); color: var(--c-on-surface); font-size: 1rem;
        display: flex; align-items: center; justify-content: center;
        box-shadow: 0 1px 3px rgba(42, 23, 19, 0.12); transition: transform 0.1s;
    }
    .mc-stepper button:active { transform: scale(0.9); }
    .mc-stepper > span {
        min-width: 30px; text-align: center; font-size: 16px; font-weight: 700;
        font-variant-numeric: tabular-nums;
    }

    .mc-plus {
        width: 100%; margin-top: var(--sp-md); min-height: 48px; cursor: pointer;
        border: 2px dashed var(--c-outline-variant); background: transparent;
        border-radius: 16px; font-family: inherit; font-size: 14px; font-weight: 700;
        color: var(--c-primary);
        display: flex; align-items: center; justify-content: center; gap: 6px;
    }
    .mc-plus:active { transform: scale(0.99); }

    /* ---------- Champ nom ---------- */
    .mc-champ { margin-top: var(--sp-xl); }
    .mc-champ label {
        display: block; margin-bottom: var(--sp-xs);
        font-size: 12px; font-weight: 700; letter-spacing: 0.06em;
        text-transform: uppercase; color: var(--c-on-surface-variant);
    }
    .mc-champ input {
        width: 100%; height: 56px; padding: 0 var(--sp-md);
        background: var(--c-surface); border: 1px solid var(--c-outline-variant);
        border-radius: 16px; font-family: inherit; font-size: 16px; color: var(--c-on-surface);
    }
    .mc-champ input::placeholder { color: var(--c-outline); }
    .mc-champ input:focus { outline: 3px solid rgba(255, 48, 8, 0.18); border-color: transparent; }

    /* ---------- Récapitulatif ---------- */
    .mc-recap {
        margin-top: var(--sp-lg); padding: var(--sp-md);
        background: var(--c-surface); border: 1px solid var(--c-outline-variant); border-radius: 16px;
    }
    .mc-recap-row { display: flex; align-items: center; justify-content: space-between; }
    .mc-recap-row > span { font-size: 16px; color: var(--c-on-surface-variant); }
    .mc-recap-val { font-weight: 600; color: var(--c-on-surface) !important; font-variant-numeric: tabular-nums; }
    .mc-recap-lbl { font-weight: 700; color: var(--c-on-surface) !important; }
    .mc-recap-sep { height: 1px; background: var(--c-outline-variant); margin: var(--sp-sm) 0; }
    .mc-recap-total {
        font-size: 28px; line-height: 34px; font-weight: 800; letter-spacing: -0.02em;
        color: var(--c-primary) !important; font-variant-numeric: tabular-nums;
    }
    .mc-recap-note {
        display: flex; align-items: center; gap: 6px; margin: var(--sp-sm) 0 0;
        font-size: 13px; color: var(--c-on-surface-variant);
    }
    .mc-recap-note i { color: var(--c-primary); font-size: 1rem; }

    /* ---------- Bouton d'envoi ---------- */
    .mc-cta {
        position: fixed; left: 0; right: 0; bottom: 0; z-index: 50;
        padding: var(--sp-md) var(--sp-pad) calc(var(--sp-lg) + env(safe-area-inset-bottom, 0px));
        background: var(--c-surface);
        background: color-mix(in srgb, var(--c-surface) 92%, transparent);
        backdrop-filter: blur(14px); -webkit-backdrop-filter: blur(14px);
        box-shadow: 0 -6px 20px rgba(42, 23, 19, 0.07);
    }
    .mc-btn {
        width: 100%; height: 56px; border: none; border-radius: 999px; cursor: pointer;
        background: var(--c-primary); color: #fff; font-family: inherit;
        font-size: 16px; font-weight: 700;
        display: flex; align-items: center; justify-content: center; gap: var(--sp-xs);
        box-shadow: 0 6px 18px rgba(255, 48, 8, 0.3); transition: transform 0.12s, opacity 0.15s;
    }
    .mc-btn:active { transform: scale(0.98); }
    .mc-btn:disabled { opacity: 0.6; cursor: wait; }
    .mc-spin { animation: mc-rot 0.9s linear infinite; display: inline-block; }
    @keyframes mc-rot { to { transform: rotate(360deg); } }
</style>
